import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { ComponentPropsWithoutRef } from "react";

import { EditPollModalComponent } from "./EditPollModalComponent";

const CompassModal = ModalManager.create(
  (
    props: Omit<
      ComponentPropsWithoutRef<typeof EditPollModalComponent>,
      "open" | "onOpenChange"
    >,
  ) => {
    const modal = useModal();

    return (
      <EditPollModalComponent
        {...props}
        open={modal.visible}
        onOpenChange={open => {
          if (!open) {
            void modal.hide();
          }
        }}
      />
    );
  },
);

export const useEditPollModal = () => useModal(CompassModal);
